import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, Well } from 'react-bootstrap';
import ConfirmDialog from './ConfirmDialog';
import LoadingProgressBar from './LoadingProgressBar';
import CSVReader from "react-csv-reader";
import { caseSetServerError, casesRefreshNeededAction } from '../../actions/caseActions';
import { contactsImportAction, casesImportAction } from '../../actions/formActions';
import { clientsRefreshNeededAction } from '../../actions/clientActions';
import { isEmptyString } from '../../validators/formValidators';


class ImportDialog extends PureComponent {
    constructor(props) {
        super(props);
        this.handleCsv = this.handleCsv.bind(this);
        this.state = {
            loading: false
        }
    }

    async handleCsv(data) {
        this.setState({ loading: true });
        if (!data || data.length == 0) {
            this.props.dispatch(caseSetServerError('Empty file.'));
            this.setState({ loading: false });
            this.props.cancel();
            return;
        }

        // PLACEHOLDER REGEX
        const headerRegex = /.*\{([a-z.A-Z0-9]+)\}.*/;
        const headers = [];
        for (let i = 0; i < data[0].length; i++) {
            const row = data[0][i].trim();
            const match = row.match(headerRegex);
            if (!match || match.length == 0) {
                this.props.dispatch(caseSetServerError(`Invalid header '${row}' on line 1 - first line must be column names with placeholder values (eg. '{FirstName}').`));
                this.setState({ loading: false });
                this.props.cancel();
                return;
            }

            headers.push(match[1]);
        }

        const values = [];
        for (let i = 1; i < data.length; i++) {
            const row = data[i];
            if (row.length !== headers.length) {
                const allEmpty = row.reduce((prev, curr) => prev && isEmptyString(curr.trim()), true);
                if (allEmpty) {
                    continue;
                }

                this.props.dispatch(caseSetServerError(`Invalid row ${i + 1}: length doesnt match the header (first row): '${JSON.stringify(row)}'.`));
                this.setState({ loading: false });
                this.props.cancel();
                return;
            }

            const value = {};
            let allEmpty = true;
            for (let j = 0; j < headers.length; j++) {
                const fieldValue = row[j].trim();
                value[headers[j]] = fieldValue;
                if (!isEmptyString(fieldValue)) {
                    allEmpty = false;
                }
            }

            if (allEmpty) {
                continue;
            }

            values.push(value);
        }

        switch (this.props.type) {
            case 'contact':
                try {
                    await this.props.dispatch(contactsImportAction(values));
                    this.props.dispatch(clientsRefreshNeededAction(true, true));
                } catch (error) {
                    this.props.dispatch(caseSetServerError(error));
                }

                break;

            case 'case':
                try {
                    await this.props.dispatch(casesImportAction(values));
                    this.props.dispatch(casesRefreshNeededAction(true));
                } catch (error) {
                    this.props.dispatch(caseSetServerError(error));
                }

                break;

            default:
                this.props.dispatch(caseSetServerError('Unknown type!'));
                break;
        }

        this.setState({ loading: false });
        this.props.cancel();
    }

    render() {
        const {
            open,
            cancel,
            fieldValue,
            title,
        } = this.props;

        return (
            <ConfirmDialog open={open}
                           cancel={cancel}
                           title={title}
            >
                <Row>
                <Col xs={12}>
                {this.state.loading ?
                    <LoadingProgressBar loading /> : 
                    <CSVReader
                        label={<Well>{`Select CSV. First line must be valid form placeholders as column names.`}</Well>}
                        onFileLoaded={this.handleCsv}
                    />
                }
                </Col>
                </Row>
            </ConfirmDialog>
        );
    }
}

ImportDialog.propTypes = {
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    cancel: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    requiredFields: PropTypes.array,
};


export default connect()(ImportDialog);